import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-white">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-24">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Política de Privacidad
          </h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Información que recopilamos</h2>
              <p>
                En David Rio Web, recopilamos información personal que usted nos proporciona voluntariamente cuando se pone en contacto con nosotros a través de nuestro formulario de contacto. Esta información puede incluir su nombre, dirección de correo electrónico, número de teléfono y cualquier otro dato que decida compartir en su mensaje.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Uso de la información</h2>
              <p>
                Utilizamos la información recopilada para los siguientes propósitos:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Responder a sus consultas y solicitudes de información</li>
                <li>Proporcionar los servicios de diseño web solicitados</li>
                <li>Mejorar nuestros servicios y la experiencia del usuario</li>
                <li>Enviar comunicaciones relacionadas con nuestros servicios, si ha dado su consentimiento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Protección de datos</h2>
              <p>
                Nos comprometemos a proteger su información personal. Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger sus datos contra el acceso no autorizado, la alteración, divulgación o destrucción.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Compartir información</h2>
              <p>
                No vendemos, intercambiamos ni transferimos su información personal a terceros sin su consentimiento, excepto cuando sea necesario para proporcionar nuestros servicios o cuando la ley lo requiera.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookies</h2>
              <p>
                Nuestro sitio web puede utilizar cookies para mejorar la experiencia del usuario. Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio. Para más información, consulte nuestra Política de Cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Sus derechos</h2>
              <p>
                De acuerdo con la normativa de protección de datos aplicable, usted tiene derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Acceder a sus datos personales</li>
                <li>Rectificar datos inexactos o incompletos</li>
                <li>Solicitar la eliminación de sus datos</li>
                <li>Oponerse al tratamiento de sus datos</li>
                <li>Solicitar la limitación del tratamiento</li>
                <li>Solicitar la portabilidad de sus datos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Retención de datos</h2>
              <p>
                Conservaremos su información personal solo durante el tiempo necesario para cumplir con los propósitos para los que fue recopilada, incluidos los requisitos legales, contables o de informes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Enlaces a otros sitios</h2>
              <p>
                Nuestro sitio web puede contener enlaces a sitios de terceros. No somos responsables de las prácticas de privacidad de estos sitios. Le recomendamos que lea las políticas de privacidad de cada sitio que visite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Cambios en esta política</h2>
              <p>
                Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en esta página. Le recomendamos que revise periódicamente esta política para estar informado sobre cómo protegemos su información.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contacto</h2>
              <p>
                Si tiene preguntas sobre esta Política de Privacidad o sobre cómo manejamos sus datos personales, puede contactarnos a través del formulario de contacto en nuestro sitio web.
              </p>
              <p className="mt-4">
                <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}